import '../../css/FormTemplate.css';
import { IFormLabelTemplate } from '../../interfaces/interface';
import FormToolTip from './FormToolTip';

const FormTemplateLabel = (props:IFormLabelTemplate) => {

    return (
        <label htmlFor={props.id}  className="form-template-label" >
            {props.label}
            {
                props.dataToolTip &&
                    <FormToolTip dataToolTip={props.dataToolTip} />    
            }
        </label>
    );
};


export default FormTemplateLabel;